import { FieldValues } from 'react-hook-form';
import isValidJSON from '@functions/isValidJSON/isValidJSON';
import { getCookie } from 'typescript-cookie';

type Props = {
    data: FieldValues;
    prefix: string;
};

export type SubmissionData = {
    last_name: string;
    email: string;
    company: string | null;
    gdpr_processing_optin: string | null;
    profile: string | null;
    form_name: string;
    page_url: string;
};

const submissionData = <T extends SubmissionData>({ data, prefix }: Props): T => {
    const entries = Object.entries(data);

    const output = {} as T;

    let country_code = '';

    let referrer_country_code = '';

    let number = '';

    let referrer_number = '';

    entries.forEach((entry) => {
        switch (typeof entry[1]) {
            case 'boolean':
                output[entry[0].replace(`${prefix}_`, '') as keyof T] = (entry[1] ? 'yes' : null) as T[keyof T];
                break;
            case 'object':
                if (isValidJSON(entry[1]?.value) && entry[0] === `${prefix}_referrer_country_code`) {
                    referrer_country_code = JSON.parse(entry[1].value).code as string;
                } else if (isValidJSON(entry[1]?.value) && entry[0] === `${prefix}_country_code`) {
                    country_code = JSON.parse(entry[1].value).code as string;
                } else {
                    output[entry[0].replace(`${prefix}_`, '') as keyof T] = entry[1]?.value as T[keyof T];
                }
                break;
            default:
                if (entry[0] === `${prefix}_referrer_phone`) {
                    referrer_number = ` ${entry[1]}`;
                } else if (entry[0] === `${prefix}_phone`) {
                    number = ` ${entry[1]}`;
                } else {
                    const entryVal = typeof entry[1] === 'string' ? entry[1].replace(/<[^>]+>/gim, '') : entry[1];
                    output[entry[0].replace(`${prefix}_`, '') as keyof T] = entryVal as T[keyof T];
                }

                break;
        }
    });

    if (!output.last_name) {
        output.last_name = 'Not Provided';
    }
    if (!output.company) {
        output.company = 'Not Provided';
    }
    if (data[`${prefix}_phone`]) {
        output['phone' as keyof T] = `${country_code}${number}` as T[keyof T];
    }
    if (data[`${prefix}_referrer_phone`]) {
        output['referrer_phone' as keyof T] = `${referrer_country_code}${referrer_number}` as T[keyof T];
    }
    if (!output.gdpr_processing_optin) {
        output.gdpr_processing_optin = null;
    }

    /* Uses a two step system to capture "multi unit" information. <Select> with a range of 1 to 5+ for UX.
    If the user selects 5+, a second field appears that allows the user to input a custom value
    (between 1 to 100). Allows to maintain the type (number) while ensuring a smooth user experience.
    CURRENTLY NOT IN USE, REMOVE LATER WHEN DECIDED. */
    // if (output['num_of_locations'] === 'more' && !!output['num_of_locations_2']) {
    //     output['num_of_locations'] = output['num_of_locations_2'];
    //     delete output['num_of_locations_2'];
    // }

    //output.form_name = window.location.href;

    output.page_url = window.location.href;

    output.profile = getCookie('persona') ? getCookie('persona') : 'none';

    return output;
};

export default submissionData;
